import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useAvatarLayerAdd() {
    const router = useAppRouter();

    const model = reactive({
        name: '',
        position: 0
    });

    const validations = {
        name: { required },
        position: { required, integer, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => avatarService.layer.create(model.name, model.position),
        onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.LAYER.INDEX })
    });

    return { model, v$, create };
}
